import { ArticleTile } from 'components/articles/ArticleTile';
import ReorderRecords from 'components/ReorderRecords';
import React from 'react';
import { connect } from 'react-redux';
import { reorderPlaylist } from 'services/api/playlists';
import { getUserPlaylists } from 'store/data/user/selectors';
import { ApplicationState, Article, UserPlaylist, UserPlaylistTrack } from 'types';
import { arrayMoveImmutable } from 'array-move';
import { Fab } from '@mui/material';
import { Icons } from 'config/icons';
import { isMobile } from 'helpers';
import { withRouter } from 'components/shell/WithRouter';

const classes = {
	fab: (offset: number) => ({
		position: isMobile() ? 'fixed' : ('absolute' as 'fixed'),
		bottom: `${offset + (isMobile() ? 75 : 20)}px; bottom: calc(${offset + (isMobile() ? 75 : 20)}px + env(safe-area-inset-bottom)/2)`,
		right: 30,
		zIndex: 1,
		width: 120,
	}),
};

interface ReorderPlaylistProps {
	playlistId: string;
	playlist: UserPlaylist;
	articles: { [id: string]: Article };
	reorderPlaylist: (playlist: UserPlaylist, orderedTracks: UserPlaylistTrack[]) => void;
	history: any;
}

let orderedTracks: UserPlaylistTrack[] = [];

const ReorderPlaylist = (props: ReorderPlaylistProps) => {
	let { playlist, articles, reorderPlaylist, history } = props;
	let navigate = history.navigate;

	let tracks: UserPlaylistTrack[] = [];
	for (let articleId in playlist!.tracks) {
		tracks.push({ articleId: articleId, order: playlist!.tracks[articleId].order });
	}
	return (
		<>
			<ReorderRecords
				records={tracks}
				getRecordId={(track) => track.articleId}
				onOrderChange={(records: any[], oldIndex: number, newIndex: number) => {
					orderedTracks = arrayMoveImmutable(records, oldIndex, newIndex);
					return orderedTracks;
				}}
				renderTile={(track, index: number) => {
					let article = articles[track.articleId];

					return <ArticleTile style={{ flexGrow: 1, marginTop: 4, marginBottom: 4 }} onClick={() => {}} record={article} />;
				}}
			/>
			<Fab
				color="primary"
				variant="extended"
				sx={classes.fab(10)}
				onClick={() => {
					if (tracks.length) {
						reorderPlaylist(playlist, orderedTracks);
					}
					navigate(-1);
				}}
			>
				{Icons.DoneAll} &nbsp; Save
			</Fab>
		</>
	);
};

function mapStateToProps(state: ApplicationState, { playlistId }) {
	let playlists = getUserPlaylists(state);

	return {
		playlist: playlists[playlistId],
		articles: state.dataState.articles.byId,
	};
}

function mapDispatchToProps(dispatch: any) {
	return {
		reorderPlaylist: (playlist: UserPlaylist, orderedTracks: UserPlaylistTrack[]) => {
			dispatch(reorderPlaylist({ playlist, orderedTracks }));
		},
	};
}

let connectedEle = connect(mapStateToProps, mapDispatchToProps)(withRouter(ReorderPlaylist));
export default connectedEle;
